/*
 * @Author: your name
 * @Date: 2021-09-29 11:46:06
 * @LastEditTime: 2021-09-29 15:02:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /error-sytem/client/@/common/js/request/token.js
 */
import dayjs from 'dayjs';
import Cookies from 'js-cookie';

import { isBrowser } from '@/utils';
interface Config {
    url?: string;
}
class Token {
    options: { overtime: number };
    tokenKey: string;
    queue: Array<any>;
    doNotToken: Array<any>;
    constructor(doNotToken: string[] = [], tokenKey = 'token') {
        this.options = {
            // 超时时间 x 分钟 失效
            overtime: 60 * 24 * 30,
        };
        this.tokenKey = tokenKey;
        this.queue = [];
        //配置不需要token的请求
        this.doNotToken = [...doNotToken, '/v1/captcha/puzzle', '/static/file/version.json'];
    }

    subscribeQueue({ resolve, reject }: { resolve: Function; reject: Function }) {
        this.queue.push({ resolve, reject });
    }
    publishQueue(token: string) {
        this.queue.forEach((item) => {
            const { resolve } = item;
            resolve(token);
        });
        this.queue = [];
    }
    clearQueue() {
        this.queue.forEach((item) => {
            const { reject } = item;
            reject(null);
        });
        this.queue = [];
    }
    set(value: string) {
        if (isBrowser()) {
            const token = JSON.stringify({
                token: value,
                time: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            });

            localStorage.setItem(this.tokenKey, token);
            Cookies.set(this.tokenKey, value, {
                expires: this.options.overtime / 1440,
            });
        }
    }

    async get(config?: Config) {
        // if (process.browser && window && window.localStorage) {

        if (!isBrowser()) {
            return '';
        }

        const { overtime } = this.options;
        const { url } = config || {};

        const value = localStorage.getItem(this.tokenKey);

        let { token, time } = value ? JSON.parse(value) : {};
        const $token = Cookies.get('token');
        token = token || $token;

        return new Promise((resolve, reject) => {
            if (!config) {
                this.subscribeQueue({ resolve, reject });
                return resolve(token);
            } else if (url && ~this.doNotToken.indexOf(url)) {
                return resolve(token);
            } else if (token && time && dayjs().toDate().getTime() > dayjs(time).add(overtime, 'minute').toDate().getTime()) {
                // 如果是超时了，就返回空
                this.set('');
                // this.subscribeQueue({ resolve, reject });
                return resolve('');
            } else if (!token) {
                this.subscribeQueue({ resolve, reject });
            } else {
                this.publishQueue(token);
                this.set(token);
                return resolve(token);
            }
        });
        // } else {
        //   return Promise.resolve('')
        // }
    }
}

export { Token };
export default new Token();
